@if (filter().inputType !== 'dropdown') {
  @if (showOptionMenuIcon()) {
    <mat-icon
      [matMenuTriggerFor]="filterOptionMenu"
      [svgIcon]="optionMenuIcon"
      (menuClosed)="onMenuClosed()"
    ></mat-icon>
  }

  <mat-menu class="filter-option-menu" #filterOptionMenu>
    <div class="filter-toggle">
      @if (!isReports()) {
        <mat-button-toggle-group mat-menu-item [formControl]="filterOptionControl" hideSingleSelectionIndicator>
          @for (menOpt of menuOptions; track menOpt.value) {
            <mat-button-toggle class="filter-toggle-button" [value]="menOpt.value" [ngClass]="menOpt.cssClass">
              {{ menOpt.label | uppercase }}
            </mat-button-toggle>
          }
        </mat-button-toggle-group>
      }
    </div>

    @if (isDateRangeFilter()) {
      <ng-container>
        <!-- Options Range-->
        @for (dateFilter of dateFilterOptions; track $index) {
          <button [disabled]="disableDateFilter" mat-menu-item>
            <div (click)="setDateRangeFilter(dateFilter)">{{ dateFilter.label }}</div>
          </button>
        }
      </ng-container>
    }

    <!-- Compound filter "Search on…" panel -->
    @if (hasCompoundFilters()) {
      <miq-compound-filter-selection
        [groups]="filterGroups()"
        [defaultSelectedKeys]="defaultSelectedKeys()"
        [selectedKeys]="currentCompoundFilterKeys()"
        (selectionChange)="onCompoundFilterSelectionChange($event)"
      ></miq-compound-filter-selection>
    }
  </mat-menu>
}
